export default __webpack_public_path__ + "3bd12268bf2febeb738e9a4f33f16cac.png";